import {
  BannerActions,
  BannerCreateRequest,
} from "../domain/banner";
import { addBannerService } from "../infrastructure/services/addBannerService";
import { tokenValidation } from "@/business/auth/application/tokenValidation";

export const addBanner = {
  async execute(position: string,
    image: File): Promise<void> {
    const request: BannerCreateRequest =
      await BannerActions().createBannerRequest(
        position,
        image
      );
    await addBannerService.execute(await tokenValidation.execute(), request);
  },
};
